import { Link } from "wouter";
import heroImage from "../assets/img/Technology_office_hero_background_c7e80786.png";

export default function Hero() {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#033644]/90 via-[#033644]/70 to-[#1E3A8A]/80"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl md:text-6xl font-heading font-bold text-white mb-6 animate-in fade-in duration-700">
          Technova
        </h1>
        <h2 className="text-3xl md:text-4xl font-heading font-semibold text-white mb-8 animate-in fade-in duration-700 delay-150">
          Soluciones Tecnológicas
        </h2>
        <p className="text-xl md:text-2xl text-gray-200 mb-10 animate-in fade-in duration-700 delay-300">
          Soluciones a medida para tu empresa
        </p>
        <Link 
          href="/contact"
          className="inline-block bg-[#FFA500] text-white font-heading font-semibold px-8 py-3 rounded-lg text-lg hover-elevate active-elevate-2 transition-all duration-300 animate-in fade-in duration-700 delay-500"
          data-testid="button-contactanos"
        >
          Contáctanos
        </Link>
      </div>
    </section>
  );
}
